// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;
}

.App {
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Existing grid/layout classes */
.savesection {
  /* Add section-specific styles here */
}

.attachmentdiv {
  /* Add attachment row styles here */
}

.savebuttonmargin {
  margin-top: 10px;
}

.savebuttonmargin-placement {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.paddingtopalldivs {
  padding-top: 12px;
}
div#maindiv {
  margin-left: 5px;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/SharedGrid.css"],"names":[],"mappings":"AAAA;;;EAGE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["html,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.App {\n  min-height: 100vh;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Existing grid/layout classes */\n.savesection {\n  /* Add section-specific styles here */\n}\n\n.attachmentdiv {\n  /* Add attachment row styles here */\n}\n\n.savebuttonmargin {\n  margin-top: 10px;\n}\n\n.savebuttonmargin-placement {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n\n.paddingtopalldivs {\n  padding-top: 12px;\n}\ndiv#maindiv {\n  margin-left: 5px;\n  margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
